class KeycapCompatibilityV2 {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('form');
    this.result = root.querySelector('[data-keycap-result]');
    this.lastState = '';
    this.openTracked = false;
    this.form.addEventListener('change', () => this.update());
    this.form.addEventListener('focusin', () => this.trackOpen(), { once: true });
  }

  trackOpen() {
    if (this.openTracked) return;
    this.openTracked = true;
    window.dataLayer?.push({ event: 'compatibility_checker_open' });
  }

  update() {
    this.trackOpen();
    const answer = (name) => this.form.querySelector(`input[name="${name}"]:checked`)?.value;
    const stem = answer('stem');
    const spacebar = answer('spacebar');
    const stabilizers = answer('stabilizers');

    if (!stem || !spacebar || !stabilizers) {
      this.render('initial', 'Check all three details', 'Your result will appear here. Keyboard percentage alone cannot confirm fit.');
      return;
    }

    if (stem === 'no') {
      this.render('not-compatible', 'Not compatible', 'This set requires a standard MX-style cross stem.');
      return;
    }

    if (spacebar === 'no') {
      this.render('not-compatible', 'Not compatible with this set', 'The supplier specification requires a 6.25U spacebar configuration.');
      return;
    }

    if (stabilizers === 'no') {
      this.render('not-compatible', 'Not compatible with the shown stabilizer layout', 'The large stabilized keys do not match the supplied compatibility guide.');
      return;
    }

    if (stem === 'yes' && spacebar === 'yes' && stabilizers === 'yes') {
      this.render('compatible', 'Compatible based on these checks', 'The stem, 6.25U spacebar, and stabilized-key layout match. Compare the full 132-key layout once more before ordering.');
      return;
    }

    if (stem === 'yes' && spacebar === 'yes' && stabilizers === 'unsure') {
      this.render('likely', 'Likely compatible — please verify key sizes', 'The stem and spacebar match, but Shift, Enter, and bottom-row sizes still need a visual check.');
      return;
    }

    this.render('unconfirmed', 'Compatibility is not confirmed', 'Remove one keycap, measure the spacebar, and compare the stabilized keys with the guides before ordering.');
  }

  render(state, title, copy) {
    this.result.dataset.state = state;
    this.result.querySelector('h2').textContent = title;
    this.result.querySelector('p').textContent = copy;

    if (state !== 'initial' && state !== 'unconfirmed' && state !== this.lastState) {
      const eventName = state === 'compatible'
        ? 'compatibility_result_compatible'
        : state === 'likely'
          ? 'compatibility_result_likely'
          : 'compatibility_result_not_compatible';
      window.dataLayer?.push({ event: eventName });
    }
    this.lastState = state;
  }
}

document.querySelectorAll('[data-keycap-checker]').forEach((root) => new KeycapCompatibilityV2(root));
